module.exports = __webpack_public_path__ + "static/media/link-alt.96036526.svg";